import { Component, EventEmitter, HostBinding, Input, OnInit, Optional, Output, ViewEncapsulation } from '@angular/core';
import { ConfigService } from 'src/app/services';


export interface ToggleConfig {
  position: CollapsePosition;
  text: string;
  icon: string;
  iconClass?: string;
}

export interface SidebarConfig {
  width?: string;
  closedWidth?: string;
  toggle?: ToggleConfig;
}

export enum CollapsePosition {
  TOP = 'top',
  BOTTOM = 'bottom'
}

@Component({
  selector: 'app-cmn-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {
  @HostBinding('class') classes = 'flex flex-1 min-h-0';
  @Input() config: SidebarConfig;

  @Input() opened: boolean;
  @Output() openedChange = new EventEmitter<boolean>();

  private configNamespace = 'common.sidebar';
  private defaults = {
    width: '320px',
    closedWidth: '0',
    toggle: {
      position: CollapsePosition.TOP,
      text: '',
      icon: '»'
    }
  };

  constructor(@Optional() configService: ConfigService) {
    this.defaults = ConfigService.SafeInit(configService, this.configNamespace, this.defaults);
  }

  ngOnInit() {
    this.config = ConfigService.MergeDefaults(this.defaults, this.config || {});
  }

  toggle() {
    this.opened = !this.opened;
    this.openedChange.emit(this.opened);
  }
}
